const {
  REACT_APP_ENV,
  REACT_APP_PROD_DEFAULT_PLANO_ID,
  REACT_APP_DEV_DEFAULT_PLANO_ID,
} = process.env;

export const ACCESS_TOKEN_KEY = "token" as const;

export const DEFAULT_PLANO_ID = Number(
  REACT_APP_ENV === "production"
    ? REACT_APP_PROD_DEFAULT_PLANO_ID
    : REACT_APP_DEV_DEFAULT_PLANO_ID
);

export const PROPOSTA_PLANO_ID_KEY = "propostaPlanoId" as const;
export const PROPOSTA_VENDEDOR_ID_KEY = "franquiaVendedorId" as const;
